import { render, staticRenderFns } from "./Contrats.vue?vue&type=template&id=715ac9fa&scoped=true"
import script from "./Contrats.vue?vue&type=script&lang=js"
export * from "./Contrats.vue?vue&type=script&lang=js"
import style0 from "./Contrats.vue?vue&type=style&index=0&id=715ac9fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ac9fa",
  null
  
)

export default component.exports